import { FC } from 'react';
import { Provider } from 'react-easyrocket';
import { useTranslation } from 'react-i18next';
import { ProviderButton } from 'src/components/Buttons/ProviderButton';
import { Spin } from 'src/components/svg/General';
import { useModalContext } from 'src/hooks/useModalContext';

interface AllProvidersResults {
  isFetching: boolean;
  providers: Provider[];
}

export const AllProviders: FC<AllProvidersResults> = ({ isFetching, providers }) => {
  const { t } = useTranslation();
  const { closeModal } = useModalContext();
  return (
    <>
      <h3 className="text-sm_all_providers_text font-bold text-base mt-3">
        {t('general.allProviders')}
      </h3>
      {isFetching ? (
        <div className="h-full w-full flex justify-center items-center self-center text-center">
          <Spin />
        </div>
      ) : (
        <div className="mt-2 grid grid-cols-2 gap-2 568:grid-cols-3">
          {providers?.map((provider) => (
            <ProviderButton provider={provider} key={provider.id} onClick={closeModal} />
          ))}
        </div>
      )}
    </>
  );
};
